export const getSingleUser = (payload?: any) => ({
    type: "@saga/GET_SINGLE_USER",
    payload
});

